import React from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import Select from 'gu-ui-kit/FormControls/Select'
import useSwitchedUser from 'utils/hooks/useSwitchedUser'
import PropTypes from 'prop-types'

const UserSwitcher = ({ email, id, className }) => {
  let req = null
  let abortController
  const { t } = useTranslation()
  const { switchedUser, switchUser } = useSwitchedUser()

  return (
    <Select
      fullWidth
      className={className}
      clearOptionLabel={t('common::select_clear_option')}
      emptyOptionLabel={t('common::select_clear_option')}
      label={t('common::user_menu.user_account')}
      mode={'filter'}
      noResultsLabel={t('common::empty_results.header')}
      requestDataFunction={({ searchPhrase }) => {
        if (abortController) {
          abortController.abort()
        }

        abortController = new AbortController()

        req = axios
          .get(`/suggest/user/suggest?q=${searchPhrase}&page=1`, {
            signal: abortController.signal,
          })
          .then(({ data }) => ({
            ...data,
            items: data.items
              .filter((item) => item.id !== id)
              .map((item) => ({
                ...item,
                value: item.id,
                label: item.text,
              })),
          }))

        return req
      }}
      size={'s'}
      t={t}
      value={switchedUser?.id}
      onChangeOption={(selectedOption) =>
        !selectedOption.empty && email !== selectedOption.label && switchUser(selectedOption.label)
      }
    />
  )
}

UserSwitcher.propTypes = {
  email: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.number,
}

export default UserSwitcher
